import React, { useEffect, useState } from "react";
import yellowalert from "src/assets/images/alert-icon-yellow.png";
import closeic from "src/assets/images/close-ic.png";
import ClearSingleCartProductFromCart from "../ClearSingleCartProductFromCart";
import QuantityPickerForUpdateCart from "../../../component/custom/QuantityPickerForUpdateCart";
import QuantityScheduler from "./QuantityScheduler";
import DisplayQtyMinQtyMult from "../../../component/custom/DisplayQtyMinQtyMult";
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { Tooltip } from "src/component/Global/Tooltip";
import System from "../../../helper/system";
import FadeInOut from "../../../component/Global/FadeInOut";
import CustomerPartNumberOptions from "../../../component/custom/CustomerPartNumberOptions";
import { isNumber } from "underscore";
import AxiosIndicatorRunTimeLoader from "../../../component/Global/AxiosIndicatorRunTimeLoader";
import ProductLegends from "src/pages/ProductListing/ProductLegends";
import { useCartStore } from "src/hooks/cart";
import noImage from "src/assets/images/noimage.png";
import Constants from "src/helper/Constants";
import { useProductStore } from "src/hooks/product";
import NavigateToProductDetail from "src/component/custom/NavigateToProductDetail";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import Helper from "src/helper/Helper";
import ProductInventoryDisplay from "src/component/custom/ProductInventoryDisplay";
import SpecialOffer from "src/component/custom/SpecialOffer";
import EditQtyMsg from "src/component/custom/EditQtyMsg";
import { InputWithDebounce } from "src/component/custom/InputWithDebounce";
import { Beacon } from "src/component/Global/Beacon";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useSystem } from "src/hooks/system";

const CartList = () => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ CART_DATA, CART_LOADER_DATA_OBJECT, VALIDATE_CART }, { update_To_Cart_Server, backorder_not_available }, { }] = useCartStore();
  const [firstServerCall, setFirstServerCall] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const [isOpenedBackOrderPopup, setIsOpenedBackOrderPopup] = useState(false);
  const [{ productList }, { get_end_customer_by_cpn }, { }] = useProductStore();
  const [{ inventoryList }, { get_inventory_by_id, get_inventory_by_distributor, get_pricing_by_id }, { },] = useProductInventoryPriceStore();
  const { siteUser, systemModules: { CART }, currencyType: { USD } } = Constants
  const { avUserInfoData: { speedBoatNameLower, currentUser } } = System
  const [,{ get_quantity_format }] = useSystem();

  const backordersObject = (v) => {
    let data = {}
    data = {
      "quantity": v.quantity,
      "ERPPartNumber": productList[v.itemNumber]?.ERPPartNumber,
      "ItemNumber": productList[v.itemNumber]?.ItemNumber,
      "ManufacturerPartNumber": productList[v.itemNumber]?.ManufacturerPartNumber,
      "ManufacturerName": v?.manufacturerName,
      "FactoryLeadTime": productList[v.itemNumber]?.FactoryLeadTime,
      "ShortDescription": productList[v.itemNumber]?.ShortDescription,
      "cartId": v.cartId,
      "cartDetailId": v.cartDetailId,
      "totalQuantity": v.quantity,
      "backOrderedQuantity": v.quantity - get_inventory_by_distributor(productList[v?.itemNumber], get_inventory_by_id(v.itemNumber))
    }
    return data
  }

  useEffect(() => {
    if (Object.entries(CART_DATA)?.length > 0 && Object.entries(productList)?.length > 0 && Object.entries(inventoryList)?.length > 0) {

      let backordered_cart_list = []
      
      Object.entries(CART_DATA).map(obj => {
        let productQty = get_inventory_by_distributor(productList[obj[1]?.itemNumber], get_inventory_by_id(obj[1]?.itemNumber))
        const checkQuantity = obj[1].quantity > productQty
        if (isOpenedBackOrderPopup === false && checkQuantity === true && (obj[1].backOrderedQuantity === 0 || (obj[1].backOrderedQuantity !== (obj[1].quantity - productQty))) && !backorder_not_available(productList[obj[1].itemNumber]) && obj[1].isProductAvailableFromMainAPI !== false && !productList[obj[1].ItemNumber]?.SoftwareDownloadFlag) {
          backordered_cart_list.push(backordersObject(obj[1]))
          setIsOpenedBackOrderPopup(true)
        }
      })

      if (!isOpenedBackOrderPopup && backordered_cart_list?.length > 0) {
        System.popup('InventoryAlertForAddToCartPopup', {
          single_product: backordered_cart_list,
          isFrom: "Cart"
        })
      }
    }

    if (firstServerCall) {
      setFirstServerCall(false);
    }
  }, [CART_DATA, productList, inventoryList])

  useEffect(() => {
    if (__check(['CART_API_CALL']).status) {
      setIsLoader(true)

    } else {
      setIsLoader(false)
    }
  }, [firstServerCall, __check(['CART_API_CALL']).status]);

  const checkBackorderInventory = (v) => {
    let productQty = get_inventory_by_distributor(productList[v.ItemNumber], get_inventory_by_id(v.ItemNumber))
    return v.quantity - productQty > 0 ? true : false
  }
  //By Ramya Kannan [View cart - Adobe script ]
  const [isCartViewEvent,setCartViewEvent] = useState(true);
  useEffect(()=>{
    if(Object.entries(CART_DATA).length &&  Object.entries(inventoryList)?.length && isCartViewEvent) {
      viewCartEvent(CART_DATA);
      setCartViewEvent(false)
    }
  },[CART_DATA,inventoryList])
  
  function viewCartEvent(cartData) {
    let prodDetails = [];
    Object.entries(cartData).map((data, i) => {
      let cpyObj = { ...data[1] };
      cpyObj.qas = get_inventory_by_id(data[1].ItemNumber)?.inventoryQty || 0;
      prodDetails.push(cpyObj);
    });
    let cartDetails = {
      additionSource: "PLP",
      cartType: "checkout",
    };
    localStorage.setItem("adobeEventType", "cartViewEvent");
    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
    }
  }

  return (
    <>
      {isLoader ? <AxiosIndicatorRunTimeLoader /> :
        <>
          {(Object.entries(CART_DATA).length === 0) ? (
            <>
              <FadeInOut show={true} duration={1000} className="cleared-cart-wrapper">
                <div className="center-link">
                  <a href={System.getHomepageUrl()} className="bs5 btn btn-primary w240">
                    Continue Shopping  </a>
                </div>
              </FadeInOut>
            </>
          ) :
            <div className="bs5 row">
              <div className="col-12">
                <div className="cart-list-table table-responsive">
                  <table className="table" >
                    <tbody>
                      {Object.entries(CART_DATA)?.length > 0 &&
                        Object.entries(CART_DATA).map((v, i) => (
                          <React.Fragment key={v[1].ItemNumber}>
                            <tr key={v[1].ItemNumber}
                              className={productList[v[1].ItemNumber] && productList[v[1].ItemNumber].NCNRFlag ? "ncnr" : "non-ncnr"} >
                              <td className="cart-list-product-img">
                                <div className="product-info nopadding">
                                  <span>Item: {i + 1}</span>
                                  <div className="product-img sect-1 text-center">
                                    <img alt="Product"
                                      src={v[1].assetURL ? v[1].assetURL : noImage} />
                                  </div>
                                  <div className="prod-option-icon sect-2 d-flex flex-wrap">
                                    <ProductLegends single_product={productList[v[1].ItemNumber]}
                                      onlyIcon={true} />
                                  </div>
                                </div>
                              </td>
                              <td className="cart-list-product-detail">
                                <div className="d-flex">
                                  <div className="product-detail">
                                    <div className={v[1]?.isProductAvailableFromMainAPI === false ? "product-name text-black mb-2" : "product-name mb-2"}>
                                      <div className="d-flex align-items-center">
                                        <span className="me-1">
                                          {(v[1].isProductAvailableFromMainAPI === false) ?
                                            v[1].ERPMFRPartNumber
                                            : (
                                              <NavigateToProductDetail
                                                data={{ SEOManufacturerName: v[1].product?.seoManufacturerName, SEOERPMFRPartNumber: v[1].product?.seoerpmfrPartNumber, ItemNumber: v[1]?.ItemNumber, ERPPartNumber: v[1]?.ERPPartNumber }}>
                                                <strong>
                                                  {v[1].ERPMFRPartNumber}
                                                </strong>
                                              </NavigateToProductDetail>
                                            )}

                                        </span>
                                        <Tooltip
                                          className='carttooltip'
                                          position={'bottom center'}
                                          opener={() => <i className={'fa fa-exclamation-circle'} />}
                                          content={() => <>
                                            <div className="text-center">
                                              {productList[v[1].ItemNumber]?.ShortDescription?.substring(0, 100)}
                                            </div>
                                            <hr />

                                            <div className="text-center">ECCN: {productList[v[1].ItemNumber]?.ECCNCode}</div>
                                            <div className="text-center">SCHEDULE B: {productList[v[1].ItemNumber]?.ScheduleBCode}</div>
                                            <div className="text-center">HTSN: {productList[v[1].ItemNumber]?.HTSCode}</div>
                                          </>}
                                        />
                                      </div>
                                      <div className="text-black-stone cursor-default">
                                        <div className="d-inline text-wrap w-auto">by&nbsp;</div>
                                        <a
                                          href={`/${speedBoatNameLower}/manufacturers/m/${Helper.replaceSpecialChar(v[1]?.manufacturerName?.toLowerCase())}/`}
                                          className="text-blue text-break cursor-pointer"
                                          title={v[1]?.manufacturerName}
                                        >
                                          {v[1]?.manufacturerName}
                                        </a>
                                      </div>
                                    </div>
                                    {v[1]?.isProductAvailableFromMainAPI !== false && (
                                      <ProductInventoryDisplay single_product={productList[v[1].ItemNumber]}
                                        single_product_inventory={get_inventory_by_id(productList[v[1].ItemNumber]?.ItemNumber)}
                                        showDashedLine={false} imageShow={false} />
                                    )}
                                  </div>

                                  {(CART_LOADER_DATA_OBJECT[v[1].ItemNumber]?.isUpdatingCpnType && __check(["CART_OPERATION_API_CALL"]).status) ? (
                                    <div className="price-table-list ms-auto">
                                      <AxiosIndicatorRunTimeLoader />
                                    </div>

                                  ) : (
                                    <>
                                      {v[1]?.isProductAvailableFromMainAPI !== false &&
                                        <div className="price-table-list ms-auto">
                                          {(System.checkIsCustomerPrice(get_pricing_by_id({ ItemNumber: v[1].ItemNumber }))) &&
                                            <div className="blue-head cpn-box">
                                              <span className="text-nowrap">Customer Specific Pricing</span>
                                              <span className="fa fa-handshake-o" />
                                            </div>
                                          }

                                          <div className="bs5 row">
                                            <div className="col-6">
                                              <span>Unit Price:</span>
                                            </div>
                                            <div className="col-6 text-end font_bold_currency">
                                              <span>
                                                {System.getFormatNumber({ amount: Number(v[1].unitPrice), currency: USD })}
                                              </span>
                                            </div>
                                          </div>

                                          <div className="bs5 row">
                                            <div className="col-6">
                                              <span>Subtotal:</span>
                                            </div>
                                            <div className="col-6 text-end font_bold_currency">
                                              <span>
                                                {isNumber(v[1].subtotal)
                                                  ? System.getFormatNumber({ amount: Number(v[1].subtotal), currency: USD, maximumFractionDigits: 2 })
                                                  : ""}
                                              </span>
                                            </div>
                                          </div>
                                          <EditQtyMsg single_product_pricing_list={get_pricing_by_id({ ItemNumber: v[1].ItemNumber })} />
                                        </div>
                                      }
                                    </>
                                  )}
                                </div>
                                {v[1]?.isProductAvailableFromMainAPI !== false &&
                                  <div className="d-flex justify-content-start part-info">
                                    <CustomerPartNumberOptions
                                      // single_product_inventory={get_inventory_by_id(v[1].ERPPartNumber)}
                                      single_product={productList[v[1].ItemNumber]}
                                      updationCompletedCallback={async (SELECTED_CUSTOMER_PART_NUMBER) => {
                                        let CPNValue = v[1].cpn
                                        if (CPNValue !== SELECTED_CUSTOMER_PART_NUMBER) {
                                          let param = {
                                            ...v[1],
                                            cartDetailId: v[1].cartDetailId,
                                            cpn: SELECTED_CUSTOMER_PART_NUMBER,
                                            endCustAccNum: get_end_customer_by_cpn(productList[v[1].ItemNumber].CustomerPartNumbers, SELECTED_CUSTOMER_PART_NUMBER),
                                            isSoftwareDownloadable: productList[v[1].ItemNumber]?.softwareDownloadFlag
                                          }
                                          await update_To_Cart_Server(param)
                                        }
                                      }}
                                      defaultValue={v[1].cpn}
                                      from={CART}
                                    />
                                    <div className="form-group">
                                      <label htmlFor="sel1">
                                        <b>Item Note</b>
                                        <Tooltip position={"bottom"} content={() => "Item Note is a free text field for your information, i.e. internal part number, on this current order. The information in this field will not be saved or available for future orders."}
                                          opener={() => (
                                            <i className="fa fa-info-circle ms-1 font-13" />
                                          )} />
                                      </label>
                                      <div>
                                        <InputWithDebounce
                                          className="form-control"
                                          type="text"
                                          placeholder="ex. 4353ES"
                                          defaultValue={v[1].referencePartNumber}
                                          onChange={async (value) => {
                                            await update_To_Cart_Server({
                                              ...v[1],
                                              referencePartNumber: value,
                                              isSoftwareDownloadable: productList[v[1].ItemNumber]?.softwareDownloadFlag
                                            })
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                }


                              </td>
                              <td className="cart-list-product-update">
                                {v[1]?.isProductAvailableFromMainAPI !== false && productList[v[1].ItemNumber] && !isLoader &&
                                  <>
                                    <FadeInOut show={true} duration={250} >
                                      <div className="quantity clearfix">
                                        <QuantityPickerForUpdateCart
                                          single_product_inventory={get_inventory_by_id(v[1].ItemNumber)}
                                          single_product={productList[v[1].ItemNumber]}
                                          single_product_pricing_list={get_pricing_by_id({ ItemNumber: v[1].ItemNumber })}
                                          single_cart_data={v[1]}
                                          qp_unique_id={v[1].cartDetailId}
                                          isFrom={CART}
                                        />
                                      </div>
                                    </FadeInOut>
                                    <div className="p-15">
                                      <div className="text-start small-text light light-text collapse_minmax">
                                        <DisplayQtyMinQtyMult
                                          single_product={productList[v[1].ItemNumber]}
                                        />
                                      </div>
                                      {((v[1].quantity > get_inventory_by_distributor(productList[v[1].ItemNumber], get_inventory_by_id(v[1].ItemNumber))) === true) && (v[1].backOrderedQuantity === 0 || (v[1].backOrderedQuantity !== (v[1].quantity - get_inventory_by_distributor(productList[v[1].ItemNumber], get_inventory_by_id(v[1].ItemNumber))))) && !backorder_not_available(productList[v[1].ItemNumber]) && !productList[v[1].ItemNumber].SoftwareDownloadFlag && (
                                        <>
                                          <a href={void 0} onClick={() => {
                                            System.popup('InventoryAlertForAddToCartPopup', {
                                              single_product: [backordersObject(v[1])],
                                              isFrom: "Cart"
                                            })
                                          }} > {" "} Backorder Remaining Quantity </a>
                                          <br />
                                        </>
                                      )}
                                      {(currentUser === siteUser.CORE && productList[v[1].ItemNumber].isAvnetDistributor && !productList[v[1].ItemNumber].SoftwareDownloadFlag) ? (
                                        <QuantityScheduler
                                          CART_DATA_SINGLE={v[1]}
                                          single_product_inventory={get_inventory_by_id(v[1].ItemNumber)}
                                          CART_PRODUCT_DATA={productList[v[1].ItemNumber]}
                                        />) : ("")}

                                    </div>
                                    {(v[1].backOrderedQuantity && v[1].backOrderedQuantity > 0) ?
                                      (
                                        <div className="bs5 row">
                                          <div className="col-6">Available:</div>
                                          <div className="col-6 text-end">
                                            {get_quantity_format(get_inventory_by_distributor(productList[v[1].ItemNumber], get_inventory_by_id(v[1].ItemNumber)))}
                                          </div>
                                        </div>
                                      ) : null}
                                    {v[1].backOrderedQuantity !== undefined && v[1].backOrderedQuantity > 0 && (
                                      <div className="bs5 row position-relative">

                                        <div className="col-6">
                                          <Beacon position={"left"} content={() => "This is the number of parts that have been backordered. Supplier Lead time will apply to the backordered parts."}
                                            opener={() => (
                                              <div className="becon-dot"></div>
                                            )} />Backordered:</div>
                                        <div className="col-6 text-end">{get_quantity_format(v[1].backOrderedQuantity)}</div>
                                      </div>
                                    )}

                                    <SpecialOffer single_product={productList[v[1].ItemNumber]} single_product_pricing_list={get_pricing_by_id({ ItemNumber: v[1].ItemNumber })}
                                      single_product_inventory={get_inventory_by_id(v[1].ItemNumber)} />
                                  </>
                                }

                                {v[1]?.isProductAvailableFromMainAPI === false &&
                                  <ClearSingleCartProductFromCart currentCartItem={v[1]} cartType={CART}>
                                    <button className="bs5 btn btn-secondary btn-sm ms-auto">
                                      Remove item from cart
                                    </button>
                                  </ClearSingleCartProductFromCart>
                                }
                              </td>
                              <td className="cart-list-close">
                                {(v[1].isProductAvailableFromMainAPI === false) &&
                                  <div className="alert alert-danger not-eligible-alert">
                                    <div className="bs5 w-100 d-flex justify-content-center">
                                      <span>
                                        You can no longer purchase this item on our site. Remove this item to proceed to Checkout.
                                      </span>
                                      <img className="ms-2" alt="Alert" src={yellowalert} />
                                    </div>
                                  </div>
                                }
                                <ClearSingleCartProductFromCart currentCartItem={v[1]} cartType={CART}>
                                  <div className="close-ic">
                                    <img src={closeic} alt="Close" />
                                  </div>
                                </ClearSingleCartProductFromCart>
                              </td>

                            </tr>
                            <tr>
                              <td className="cart-list-error"></td>
                              <td colSpan={3} className="cart-list-error">

                              
                                {(productList[v[1].ItemNumber] && productList[v[1].ItemNumber].ObsoleteFlag && checkBackorderInventory(v[1])) && (
                                  <div className="alert alert-danger not-eligible-alert">
                                    <div className="bs5 w-100 d-flex justify-content-center">
                                      <span>Unable to back order obsolete Item</span>
                                      <img className="ms-2" alt="Alert" src={yellowalert} />
                                    </div>
                                  </div>
                                )}

                                {(productList[v[1].ItemNumber] && productList[v[1].ItemNumber].EndOfLifeFlag && checkBackorderInventory(v[1])) && (
                                  <div className="alert alert-danger not-eligible-alert">
                                    <div className="bs5 w-100 d-flex justify-content-center">
                                      <span>Unable to back order EOL Item</span>
                                      <img className="ms-2" alt="Alert" src={yellowalert} />
                                    </div>
                                  </div>
                                )}

                                {((productList[v[1].ItemNumber]?.specialPriceFlag || productList[v[1].ItemNumber]?.constrainPartFlag || productList[v[1].ItemNumber]?.isPartnerDistributor || productList[v[1].ItemNumber]?.isNewarkDistributor || productList[v[1].ItemNumber]?.ExcessInventoryFlag) && checkBackorderInventory(v[1])) && (
                                  <div className="alert alert-danger not-eligible-alert">
                                    <div className="bs5 w-100 d-flex justify-content-center">
                                      <span>Unable to backorder as the order quantity has exceeded the existing quantity in stock.</span>
                                      <img className="ms-2" alt="Alert" src={yellowalert} />
                                    </div>
                                  </div>
                                )}

                                {(productList[v[1].ItemNumber] && productList[v[1].ItemNumber].NCNRFlag) && (
                                  <div className="alert alert-dark ncnr-alert justify-content-center">
                                    <b>NCNR:</b> <span>Non-Cancelable/Non-Returnable</span>
                                  </div>
                                )}
                              </td>
                            </tr>
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          }
        </>
      }
    </>
  );
};

export default CartList;